<p-toast />
<p-confirmDialog #cd appendTo="body" (onHide)="close()">
  <ng-template pTemplate="header">
    <p
      class="font-bold text-xl"
      [innerHTML]="header | highlight : '¡Importante!'"
    ></p>
  </ng-template>
  <ng-template pTemplate="footer">
    @if(cancelButton) {
    <div class="flex justify-between w-full">
      <app-button [texto]="rejectLabel" color="gray" colorTexto="black" (clickBtn)="cd.onReject()" />
      <app-button [texto]="acceptLabel" color="primary" colorTexto="white" (clickBtn)="cd.onAccept()" />
    </div>
    } @else {
    <app-button texto="Confirmar" color="primary" colorTexto="white" (clickBtn)="cd.onAccept()" />
    }
  </ng-template>
</p-confirmDialog>
